import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { BbTableService } from '../../../services/bb-table.service';
import { Subscription } from 'rxjs';
import { LiveApiService } from '../../../services/live-api.service';
import { LiveStreamDetails, LiveStreamRestreamsList, LiveStreamRestreamType, LiveStreamRestreamState } from '../../../interfaces/live';

const MAX_TABLE_ROWS = 10;

@Component({
	selector: 'mediaclip-details-restreaming',
	templateUrl: './mediaclip-details-restreaming.component.html',
	styleUrls: ['./mediaclip-details-restreaming.component.scss']
})

export class MediaclipDetailsRestreamingComponent implements OnInit, OnChanges {

	@Input() mediaclip: Mediaclip;
	@Input() liveStreamDetails: LiveStreamDetails;
	@Input() form: NgForm;
	@Input() isActive: boolean;

	restreams: any[];
	restreamRows: any[];

	subscriptions: Subscription;

	mayEditRestreams: boolean;

	streamUuid: string;

	haveUnsavedNewRestreams: boolean;

	constructor(
		private bbTableService: BbTableService,
		private liveApiService: LiveApiService) {
		this.bbTableService
			.setConfigurable(false)
			.setLimit(MAX_TABLE_ROWS);

		this.restreams = [];
		this.restreamRows = [];

		this.haveUnsavedNewRestreams = false;
	}

	getRestreams() {
		if (this.liveStreamDetails) {
			this.streamUuid = this.liveStreamDetails.data.id;

			if (this.streamUuid) {
				this.liveApiService.getRestreams(this.streamUuid).subscribe((res: LiveStreamRestreamsList) => {
					res.data.forEach((restream: any) => {
						// Currently there's only one available restream type, API doesn't return it so we just fill the value here
						restream['restream-type'] = LiveStreamRestreamType.rtmp;
					});

					this.restreams = res.data;
				});
			}
		}
	}

	ngOnInit() {
		this.getRestreams();
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges && simpleChanges.liveStreamDetails) {
			this.getRestreams();
		}
	}

	determineUnsavedRestreams() {
		if (this.haveUnsavedNewRestreams) {
			this.haveUnsavedNewRestreams = this.restreamRows.filter((row) => row.id === 'new').length > 0;
		}
	}

	onItemRemoved(items: any[], index: number) {
		items.splice(index, 1);
		this.determineUnsavedRestreams();
	}

	onItemSaved() {
		this.determineUnsavedRestreams();
	}

	openPublicUrl(item: any) {
		if (item['public-url']) {
			const win = window.open(item['public-url']);
			win.focus();
		}
	}

	newRestream() {
		this.haveUnsavedNewRestreams = true;

		this.restreams.unshift({
			id: 'new',
			'restream-type': LiveStreamRestreamType.rtmp,
			'restream-name': '',
			state: LiveStreamRestreamState.enabled,
			quickEditing: true
		});
	}
}
